import { V1 } from './net'
import { createAppAsyncThunk } from 'store/state'

import { firstValueFrom } from 'rxjs'

/**
 * Fetch details about web page by its url
 *
 */
export const getLinkDetails = createAppAsyncThunk(
  'composer/getLinkDetails',
  async (params: { url: string, isPinterestDestinationUrl?: boolean }, { dispatch, rejectWithValue }) => {
    const { url, isPinterestDestinationUrl } = params
    try {
      const response = await firstValueFrom(dispatch(V1.getLinkDetails(url)))
      if (response.url) {
        return { link: response, isPinterestDestinationUrl }
      }
      return rejectWithValue('Invalid link response')

    } catch (e) {
      return rejectWithValue(e)
    }
  }
)
